module.exports = __webpack_public_path__ + "img/9beb048.svg";